import { RestApiResponse } from "./RestApi";
import {
  BusinessOwnerDashboardRequestAttributes,
  BusinessOwnerAccountAndBusinessesAttributes,
  BusinessOverviewAttributes,
  SetOwnerAsManagerAttributes,
  InviteManagerAttributes,
  AddBranchAttributes,
  ListBranchesAttributes,
  ListManagersAttributes,
  GetManagerDetailAttributes,
  ApproveManagerAttributes,
  DeclineManagerAttributes,
  RequestMoreInfoFromManagerAttributes,
  ActivityRequestAttributes,
} from "../attributes/business-owner-attributes";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";

export class BusinessOwnerService extends BaseService {
  static async resume(
    data: BusinessOwnerDashboardRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/wallets/resume`,
      data
    );
  }

  static async getAccountAndBusinesses(
    data: BusinessOwnerAccountAndBusinessesAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/account-and-businesses`,
      data
    );
  }

  static async getBusinessOverview(
    data: BusinessOverviewAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/overview`,
      data
    );
  }

  static async setOwnerAsManager(
    data: SetOwnerAsManagerAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/set-owner-as-manager`,
      data
    );
  }

  static async inviteManager(
    data: InviteManagerAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/invite-manager`,
      data
    );
  }

  static async addBranch(
    data: AddBranchAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/add-branch`,
      data
    );
  }

  static async listBranches(
    data: ListBranchesAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/list-branches`,
      data
    );
  }

  static async listManagers(
    data: ListManagersAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/list-managers`,
      data
    );
  }

  static async getManagerDetail(
    data: GetManagerDetailAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/manager-detail`,
      data
    );
  }

  static async approveManager(
    data: ApproveManagerAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/approve-manager`,
      data
    );
  }

  static async declineManager(
    data: DeclineManagerAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/decline-manager`,
      data
    );
  }

  static async requestMoreInfoFromManager(
    data: RequestMoreInfoFromManagerAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/request-more-info-from-manager`,
      data
    );
  }

  static async getActivities(
    data: ActivityRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/activities`,
      data
    );
  }

  static async resumeRefund(
    data: BusinessOwnerDashboardRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/wallets/resume-refund`,
      data
    );
  }

  static async resumeWithdraw(
    data: BusinessOwnerDashboardRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/wallets/resume-withdraw`,
      data
    );
  }

  static async resumeRecharge(
    data: BusinessOwnerDashboardRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessOwnerService.getApiClient().post(
      `businesses/wallets/resume-recharge`,
      data
    );
  }
}

export default BusinessOwnerService;
